/*
 * TargetingPeeqPage Messages
 *
 * This contains all the text for the TargetingPeeqPage component.
 */
import { defineMessages } from 'react-intl';

export const scope = 'app.containers.TargetingPeeqPage';

export default defineMessages({
  pausePeeqAudience: {
    id: `${scope}.pausePeeqAudience`,
    defaultMessage: 'Pause audience',
  },
  resumePeeqAudience: {
    id: `${scope}.resumePeeqAudience`,
    defaultMessage: 'Resume audience',
  },
  renamePeeqAudience: {
    id: `${scope}.renamePeeqAudience`,
    defaultMessage: 'Rename',
  },
  audienceList: {
    duplicateAudience: {
      id: `${scope}.audienceList.duplicateAudience`,
      defaultMessage: 'Duplicate',
    },
    deleteAudience: {
      id: `${scope}.audienceList.deleteAudience`,
      defaultMessage: 'Delete',
    },
    addAudience: {
      id: `${scope}.audienceList.addAudience`,
      defaultMessage: 'Add Audience',
    },
    title: {
      id: `${scope}.audienceList.title`,
      defaultMessage: 'Audience {index}',
    },
    completes: {
      id: `${scope}.audienceList.completes`,
      defaultMessage: 'ie: 600',
    },
    completesLabel: {
      id: `${scope}.audienceList.completesLabel`,
      defaultMessage: 'Completes',
    },
    quotaSumError: {
      id: `${scope}.audienceList.quotaSumError`,
      defaultMessage: 'The sum needs to add up to {completes}',
    },
    temporaryTooltip: {
      id: `${scope}.audienceList.temporaryTooltip`,
      defaultMessage:
        'This is a temporary audience containing replenished responses that have been removed by our fraud detection system. Feel free to update or remove it.',
    },
    peeqCommon: {
      id: `${scope}.audienceList.peeqCommon`,
      defaultMessage:
        'Survey language and Country are common for all audiences',
    },
    isActive: {
      id: `${scope}.audienceList.isActive`,
      defaultMessage: 'Active',
    },
    isInactive: {
      id: `${scope}.audienceList.isInactive`,
      defaultMessage: 'Inactive',
    },
  },
  audienceRemovalModal: {
    header: {
      id: `${scope}.audienceRemovalModal.header`,
      defaultMessage: 'Remove "{name}"',
    },
    descriptionOnlyTaxonomy: {
      id: `${scope}.audienceRemovalModal.descriptionOnlyTaxonomy`,
      defaultMessage:
        'The audience "{name}" contains criteria that are used in logic. If you remove the audience, all the logic rules assigned to this audience criteria will also be removed.',
    },
    descriptionOnlyLoopAndMerge: {
      id: `${scope}.audienceRemovalModal.descriptionOnlyLoopAndMerge`,
      defaultMessage:
        'This audience contains criteria that are used in Loop & Merge. If you remove it, the associated Loop & Merge configuration will also be removed. Are you sure you want to remove it?',
    },
    descriptionTaxonomyAndLoopAndMerge: {
      id: `${scope}.audienceRemovalModal.descriptionTaxonomyAndLoopAndMerge`,
      defaultMessage:
        'This audience contains criteria that are used in advanced logic and Loop & Merge. If you remove it, the associated rules and Loop & Merge configuration will also be removed. Are you sure you want to remove it?',
    },
    descriptionNotDraftOnlyLoopAndMerge: {
      id: `${scope}.audienceRemovalModal.descriptionNotDraftOnlyLoopAndMerge`,
      defaultMessage:
        'This audience contains criteria that are used in the Loop & Merge. If you remove it, the associated Loop & Merge configuration will remain unchanged, but respondents may skip and not answer the Loop & Merge question group. Are you sure you want to remove it?',
    },
    descriptionNotDraftTaxonomyAndLoopAndMerge: {
      id: `${scope}.audienceRemovalModal.descriptionNotDraftTaxonomyAndLoopAndMerge`,
      defaultMessage:
        'This audience contains criteria that are used in advanced logic and Loop & Merge. If you remove it, the associated rules will be removed. Loop & Merge configuration will remain unchanged, but respondents may skip and not answer the Loop & Merge question group. Are you sure you want to remove it?',
    },
  },
  audienceAddButtons: {
    new: {
      id: `${scope}.new`,
      defaultMessage: 'New!',
    },
    addFromTemplates: {
      id: `${scope}.addFromTemplates`,
      defaultMessage: 'Add from templates',
    },
    addFromScratch: {
      id: `${scope}.addFromScratch`,
      defaultMessage: 'Add from scratch',
    },
  },
  saveAsTemplate: {
    id: `${scope}.saveAsTemplate`,
    defaultMessage: 'Save as template',
  },
});
